
//export const base_url = 'http://localhost:3000/'; 
export const base_url = 'https://escouae.org/'; 
//export const base_url = 'https://ccme.ae/'; 
export const api_base_url = 'https://escouae.org/demoadmin/public/api/'; 
//export const api_base_url = 'https://ccme.ae/admin/public/api/'; 
 